import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Breadcrumb } from 'src/app/shared/breadcrumb/breadcrumb';
import { TitleService } from 'src/app/shared/title.service';
import { UserService } from '../user.service';

interface SectionMenu {
  label: string;
  param: string;
}

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
  standalone: false
})
export class UserSettingsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private titleService = inject(TitleService);
  private userService = inject(UserService);

  menus: SectionMenu[] = [
    {
      label: 'Profile',
      param: 'profile'
    },
    {
      label: 'Password',
      param: 'password'
    }
  ];
  section = this.menus[0].param;

  ngOnInit() {
    this.titleService.setTitle('Settings');
    this.route.queryParams.subscribe((queryParams) => {
      this.section = queryParams['section'];
    });
  }

  get currentSectionMenu(): SectionMenu {
    const menu = this.menus.find((menu) => menu.param === this.section);
    return menu ?? this.menus[0];
  }

  get menuLabels(): string[] {
    return this.menus.map((menu) => menu.label);
  }

  get selectedMenuIndex(): number {
    const menuIndex = this.menus.findIndex((menu) => menu.param === this.section);
    return menuIndex >= 0 ? menuIndex : 0;
  }

  onClickMenu(index: number) {
    this.router.navigate([], {
      queryParams: { section: this.menus[index].param }
    });
  }

  get breadcrumbList(): Breadcrumb[] {
    return [{ name: 'Settings' }, { name: this.currentSectionMenu.label }];
  }

  get userInfo() {
    return this.userService.userInfo;
  }
}
